export default "__VITE_ASSET__xYij7LIx__"